import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  TemplateRef,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { InteractorService } from 'src/app/core/services/interactor.service';
import { LookupService } from 'src/app/core/services/lookup.service';

@Component({
  selector: 'app-confirm-discard',
  templateUrl: './confirm-discard.component.html',
  styleUrls: ['./confirm-discard.component.scss']
})
export class ConfirmDiscardComponent implements OnInit, OnDestroy {
  modalRef: BsModalRef;
  @Input() Message = 'Do you want to discard the unsaved changes?';
  @Input() ModalTriggerFrom = null;
  @Output() modalEvent = new EventEmitter<boolean>();
  @Output() childValueDiscardmodalEvent = new EventEmitter<boolean>();
  @ViewChild('template') elementView: TemplateRef<any>;
  @Input() btnLabel = 'OK';
  @Input() cancelBtnLabel = 'Cancel';
  brandingDetails = JSON.parse(localStorage.getItem('branding'));
  btnDelete=this.brandingDetails?.branding?.BackgroundColors?.ConfirmDeleteBtnHover;
  constructor(
    private modalService: BsModalService,
    private interactorService: InteractorService,
    private translatorService: TranslateService,
    private lookupService: LookupService) {
      this.translatorService.setDefaultLang('en');
      this.translatorService.use(localStorage.getItem('lang') || 'en');
    }

  ngOnInit(): void {
    this.interactorService.brandingDetailsCast.subscribe(data => {
      if (data) {
        this.brandingDetails = data;
        document.documentElement.style.setProperty('--btnDelete', this.brandingDetails?.branding?.BackgroundColors?.ConfirmDeleteBtnHover);
      }
      this.setBackgroundColors();
    });
     this.interactorService.inviteToCompleteBrandingDetailsCast.subscribe(data => {
      if (data) {
        this.brandingDetails = data;
        document.documentElement.style.setProperty('--btnDelete', this.brandingDetails?.branding?.BackgroundColors?.ConfirmDeleteBtnHover);
      }
      this.setBackgroundColors();
    });

    document.documentElement.style.setProperty('--btnDelete', this.brandingDetails?.branding?.BackgroundColors?.ConfirmDeleteBtnHover);
  }

  /**
   * Function to open modal
   */
  public openModal() {
    // Close any existing modal first
    this.closeModal();
    this.updateModalStatus(true);
    this.modalRef = this.modalService.show(this.elementView, {
      class: 'modal-dialog-centered',
      ignoreBackdropClick: true
    });
  }

  /**
   * Function to close modal and emit event
   */
  public confirm(value) {
    this.updateModalStatus(false);
    value = this.ModalTriggerFrom ? { value: value, ModalTriggerFrom: this.ModalTriggerFrom } : value;
    // Safely close the modal
    this.closeModal();
    this.modalEvent.emit(value);
  }

  /**
   * Safely close the modal with proper cleanup
   */
  private closeModal() {
    if (this.modalRef) {
      try {
        this.modalRef.hide();
      } catch (error) {
        console.warn('Error hiding modal:', error);
      } finally {
        this.modalRef = null;
      }
    }
  }

  /**
   * Handle component destruction
   */
  ngOnDestroy() {
    this.closeModal();
  }
  setBackgroundColors(){
    this.btnDelete=this.brandingDetails?.branding?.BackgroundColors?.ConfirmDeleteBtnHover;
  }
  updateModalStatus(value) {
  if(window?.location?.pathname.includes('/people/details')){
     this.lookupService.updateActiveModalState(value);
    }
  }
}
